import { tokens } from "../../theme";

interface DccLogoProps {
  height?: number;
  color?: string;
  title?: string;
}

/**
 * Isotipo del DCC (monograma) en SVG. Se colorea vía `color` (blanco por
 * defecto, para fondos azules del header/footer). Las trazas heredan el `fill`.
 */
export default function DccLogo({ height = 32, color = tokens.neutro.blanco, title = "DCC" }: DccLogoProps) {
  const width = Math.round((height * 362) / 194);
  return (
    <svg
      role="img"
      aria-label={title}
      height={height}
      width={width}
      viewBox="192 79 362 194"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", flexShrink: 0 }}
    >
      <path d="M425.2,227c-6.3,5.5-14.5,8.9-23.5,8.9-19.7,0-35.6-16-35.6-35.6s16-35.6,35.6-35.6,17.2,3.4,23.5,8.9c3.3-9.1,8.2-17.4,14.4-24.6-10.6-7.8-23.7-12.5-37.9-12.5-35.3,0-63.9,28.6-63.9,63.9s28.6,63.9,63.9,63.9,27.3-4.6,37.9-12.5c-6.2-7.2-11.1-15.5-14.4-24.6h0Z" />
      <path d="M300,87v59.8c-10.2-6.9-22.5-10.9-35.8-10.9-35.4,0-64.1,28.7-64.1,64.1s28.7,64.1,64.1,64.1,25.5-4,35.8-10.9v10.9h28.3V87h-28.3ZM289.9,224.9c-6.5,6.7-15.6,10.9-25.7,10.9-19.7,0-35.8-16-35.8-35.8s16-35.8,35.8-35.8,19.2,4.2,25.7,10.9c6.2,6.4,10.1,15.2,10.1,24.9s-3.8,18.4-10.1,24.9h0Z" />
      <path d="M523.5,173.8c-6.3-5.8-14.8-9.3-24-9.3-19.7,0-35.6,16-35.6,35.7s16,35.6,35.6,35.6,19.1-4.1,25.6-10.8l20.2,19.8c-11.6,11.9-27.8,19.3-45.8,19.3-35.3,0-63.9-28.6-63.9-63.9s28.6-63.9,63.9-63.9,32.2,6.5,43.6,17.2l-19.6,20.4h0Z" />
    </svg>
  );
}
